import React from 'react'
import ChangePasswordForm from './components/changePasswordForm'
import Row from 'components/Row'
import Col from 'components/Col'
import Container from 'components/Container'


const ChangePasswordPage = () => {
  return <Container>
    <Row>
      <Col md={8} mdOffset={2}>
        <ChangePasswordForm />
      </Col>
    </Row>
  </Container>
}

export default ChangePasswordPage
